const BLOG_TAG_COLORS_REGISTRY = {
  Interview: { background: "#B8EDFF", text: "#06354B" },
  "Micro-learning": { background: "#DFD8FC", text: "#311461" },
} as const satisfies Record<string, { background: string; text: string }>;

export function useBlogTagColors(tag: string = "Interview") {
  return (
    BLOG_TAG_COLORS_REGISTRY[tag as keyof typeof BLOG_TAG_COLORS_REGISTRY] || {
      background: "#fef1fa",
      text: "#580030",
    }
  );
}
